import { dispatchRefreshEvent } from "helpers/utils";
import React, { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchRegistrationTypes, saveSelectedRow, setIsEditingFlag } from "stores/redux/slice/personRoleSetup";



function CopyRow({ row, columns, containerRef, controller }) {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    const id = setTimeout(() => {
      dispatch(setIsEditingFlag(true));
      dispatch(saveSelectedRow({
        ...row,
        personRoleEnumId: "",
        modifiedDate: "",
        createdDate: "",
        modifiedBy: "",
        createdBy: ""
      }));
      dispatch(fetchRegistrationTypes({ personRoleEnumId: '' }));
      controller.highlightRow(-1);
    }, 200);

    return () => {
      dispatch(setIsEditingFlag(false));
      clearTimeout(id);
    };
  }, [containerRef, controller, dispatch, row]);
  return (
    <tr className="active" data-id="person-role-setup-browser_Row_24">
      {columns.map((column) => (
        <>
          <td key={column.name}>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <span>{column.renderCell ? column.renderCell(row) : row[column.name]}</span>
              </div>
            </div>
          </td>
        </>
      ))}
      <td>
        <button
          data-id="inst-contacts-delete-row-0"
          onClick={() => dispatchRefreshEvent()}
          type="button"
          className="grid-fn-btn delete"
          title="Delete Copied Row"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="trash-alt"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className="svg-inline--fa fa-trash-alt"
          >
            <path
              fill="currentColor"
              d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
            >
            </path>
          </svg>
        </button>
      </td>
    </tr>
  );
}

export default CopyRow;
